import { activeGateWayOnlinePayment } from 'Global/Adapters/activeGateWayOnlinePayment';
import React, { useEffect, useState } from 'react';

const useCheckActivatedPaymentGateways = () => {
  const [gateways, setGateWays] = useState(null);
  useEffect(() => {
    activeGateWayOnlinePayment(setGateWays);
  }, []);

  return gateways;
};

export default useCheckActivatedPaymentGateways;
